module.exports = __webpack_public_path__ + "static/media/em-220.abde5310.png";